import api from './api';

export type Coordinates = {
  lat: number;
  lng: number;
};

export type LocationResponse = {
  success: boolean;
  message: string;
  data?: {
    id: string;
    userId?: string;
    lat: number;
    lng: number;
    createdAt: string;
    updatedAt: string;
  };
};

/**
 * Save user location to the backend
 * @param coordinates User's geographical coordinates
 * @returns Promise with the API response
 */
export const saveUserLocation = async (coordinates: Coordinates): Promise<LocationResponse> => {
  try {
    const response = await api.get<LocationResponse>('/geo/city', { params: coordinates });
    return response.data;
  } catch (error: any) {
    console.error('Error saving location:', error.response?.data || error.message || error);
    // Re-throw the error with a more descriptive message
    throw new Error(error.response?.data?.message || 'Failed to save location data');
  }
};

/**
 * Get nearby events based on user location
 * @param coordinates User's geographical coordinates
 * @param radius Search radius in kilometers (optional)
 * @returns Promise with nearby events
 */
export const getNearbyEvents = async (coordinates: Coordinates, radius?: number): Promise<any> => {
  try {
    const params = { ...coordinates };
    if (radius) {
      Object.assign(params, { radius });
    }
    
    const response = await api.get('/events/nearby', { params });
    return response.data;
  } catch (error: any) {
    console.error('Error fetching nearby events:', error.response?.data || error.message || error);
    throw new Error(error.response?.data?.message || 'Failed to fetch nearby events');
  }
};

/**
 * Check if the location API is available
 * @returns Promise with a boolean indicating if the API is available
 */
export const checkLocationApiAvailability = async (): Promise<boolean> => {
  try {
    await api.get('/health');
    return true;
  } catch (error) {
    console.error('Location API is not available:', error);
    return false;
  }
}; 